export const GameVertical = {
  Exchange: "Exchange",
  Sports: "Sports",
  Casino: "Casino",
  SportsIndia: "SportsIndia",
  SAP: "SAP",
} as const;

